import React, { useState, useEffect, useRef } from 'react';
import './index.css';
import { 
  getArchiveStats, 
  getMyPosts, 
  deletePost,
  getCurrentUser,
  getUserStats
} from '../../data/postsData';
import { useNavigate } from 'react-router-dom';

const About = () => {
  const [activeTab, setActiveTab] = useState('profile');
  const [siteStats, setSiteStats] = useState(null);
  const [loadingStats, setLoadingStats] = useState(true);
  const navigate = useNavigate();
useEffect(() => {
    // 检查登录状态，未登录则跳转到登录页
    const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
    if (!isLoggedIn) {
      navigate('/auth');
    }
  }, [navigate]);
  // 获取当前登录用户（从postsData的getCurrentUser获取）
  const currentUser = getCurrentUser();
  const userId = currentUser.id;

  // 个人资料相关状态（同步真实登录用户信息）
  const [userInfo, setUserInfo] = useState({
    avatar: currentUser.avatar || '🐶',
    nickname: currentUser.name,
    intro: currentUser.intro || '一个热爱生活的小狗主题博主，用文字记录美好瞬间～'
  });
  const [editingProfile, setEditingProfile] = useState(false);
  const [tempUserInfo, setTempUserInfo] = useState({ ...userInfo });
  const [saveError, setSaveError] = useState('');

  // 我的文章相关状态（使用getMyPosts获取，支持草稿/已发布）
  const [myArticles, setMyArticles] = useState([]);
  const [userStats, setUserStats] = useState({ posts: 0, drafts: 0 });
  const deleteConfirmRef = useRef(null);
  const [targetArticleId, setTargetArticleId] = useState('');

  // 新增：密码修改相关状态
  const [showPwdModal, setShowPwdModal] = useState(false);
  const [oldPwd, setOldPwd] = useState('');
  const [newPwd, setNewPwd] = useState('');
  const [confirmPwd, setConfirmPwd] = useState('');
  const [pwdError, setPwdError] = useState('');

  // 获取站点统计数据
  useEffect(() => {
    const loadSiteStats = () => {
      setTimeout(() => {
        try {
          const archiveData = getArchiveStats();
          const stats = {
            totalAuthors: archiveData.byCategory.length,
            totalPosts: archiveData.total,
            totalViews: archiveData.monthlyStats.reduce((sum, month) => sum + month.views, 0),
            runningYears: 3
          };
          setSiteStats(stats);
        } catch (error) {
          console.error('加载站点统计数据失败:', error);
          setSiteStats({
            totalAuthors: 1200,
            totalPosts: 5800,
            totalViews: 120000,
            runningYears: 3
          });
        } finally {
          setLoadingStats(false);
        }
      }, 300);
    };
    loadSiteStats();
  }, []);

  // 获取我的文章列表（修复核心问题：使用getMyPosts）
  useEffect(() => {
    const fetchMyArticles = () => {
      // 获取当前用户的所有文章（包括草稿）
      const userPosts = getMyPosts(userId);
      // 格式化文章数据
      const formattedPosts = userPosts.map(post => ({
        ...post,
        status: post.published ? 'published' : 'draft',
        readCount: post.views || 0
      }));
      setMyArticles(formattedPosts);
      // 更新用户统计数据
      setUserStats(getUserStats(userId));
    };

    fetchMyArticles();
    // 监听数据变更，实时更新文章列表
    window.addEventListener('blogDataChanged', fetchMyArticles);
    return () => {
      window.removeEventListener('blogDataChanged', fetchMyArticles);
    };
  }, [userId]);

  // 编辑资料
  const handleEditProfile = () => {
    setTempUserInfo({ ...userInfo });
    setEditingProfile(true);
    setSaveError('');
  };

  // 保存个人资料
  const handleSaveProfile = () => {
    try {
      setTimeout(() => {
        setUserInfo({ ...tempUserInfo });
        setEditingProfile(false);
        setSaveError('');
        alert('资料保存成功 🐾');
      }, 500);
    } catch (error) {
      setSaveError('保存失败，请重试 🐶');
    }
  };

  // 取消编辑资料
  const handleCancelEdit = () => {
    setEditingProfile(false);
    setSaveError('');
  };

  // 新增：处理头像上传
  const handleAvatarUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // 限制文件大小（5MB）
    if (file.size > 5 * 1024 * 1024) {
      alert('头像文件不能超过5MB哦 🐶');
      return;
    }

    // 模拟上传
    const reader = new FileReader();
    reader.onload = (event) => {
      setUserInfo({...userInfo, avatar: event.target.result});
      alert('头像上传成功啦 🐾');
    };
    reader.readAsDataURL(file);
  };

  // 新增：处理密码修改
  const handleUpdatePwd = () => {
    if (!oldPwd) return setPwdError('请输入原密码 🐶');
    if (newPwd.length < 6 || newPwd.length > 16) return setPwdError('新密码需6-16位 🐾');
    if (newPwd !== confirmPwd) return setPwdError('两次密码不一致 ❌');
    if (oldPwd === newPwd) return setPwdError('新密码不能和原密码相同 🐕');

    setTimeout(() => {
      setPwdError('');
      setShowPwdModal(false);
      setOldPwd('');
      setNewPwd('');
      setConfirmPwd('');
      alert('密码修改成功，请重新登录 🎉');
    }, 800);
  };

  // 打开删除确认弹窗
  const openDeleteConfirm = (articleId) => {
    setTargetArticleId(articleId);
    deleteConfirmRef.current.style.display = 'flex';
  };

  // 关闭删除确认弹窗
  const closeDeleteConfirm = () => {
    deleteConfirmRef.current.style.display = 'none';
    setTargetArticleId('');
  };

  // 确认删除文章（调用postsData的deletePost）
  const confirmDeleteArticle = () => {
    setTimeout(() => {
      deletePost(targetArticleId);
      setMyArticles(myArticles.filter(article => article.id !== targetArticleId));
      closeDeleteConfirm();
      alert('文章删除成功 🐾');
    }, 300);
  };

  // 修复：编辑文章跳转（路径改为/write，参数用查询参数）
  const handleEditArticle = (articleId) => {
    navigate(`/write?id=${articleId}`);
  };

  // 预览文章跳转
  const handlePreviewArticle = (articleId) => {
    navigate(`/post/${articleId}`);
  };

  // 精简版FAQ
  const simplifiedFaqs = [
    {
      question: '如何删除已发布的文章？',
      answer: '进入「我的文章」页面，hover对应文章卡片，点击「删除」按钮，按弹窗提示确认即可。'
    },
    {
      question: '更换头像后不显示怎么办？',
      answer: '1. 刷新页面重试；2. 检查头像图片格式（支持jpg/png）；3. 确保图片大小不超过5MB。'
    },
    {
      question: '忘记密码如何找回？',
      answer: '点击右上角头像弹窗的「登录」按钮，在登录页选择「忘记密码」，按提示绑定手机号找回。'
    }
  ];

  // 精简版关于平台内容
  const simplifiedMilestones = [
    { year: '2025.', month: '11', event: 'Puppy Log 想法诞生', desc: '在一个阳光明媚的早晨，萌生了创建这个温暖博客的想法' },
    { year: '2025.', month: '12', event: '第一个版本上线', desc: '完成了基础功能开发，博客正式上线' }
  ];

  return (
    <div className="about-page fade-in">
      {/* 标题区域优化 */}
      <section className="about-hero profile-header">
        <div className="hero-content title-group">
          <span className="puppy-icon-big">🐶</span>
          <h1 className="main-title">Puppy Log 个人中心</h1>
          <p className="sub-title">用小狗般的温柔，记录生活的小确幸</p>
          
          <div className="hero-subtitle-area">
            <p className="hero-subtitle-desc">一个温暖可爱的小狗主题博客社区</p>
            <div className="hero-highlights">
              <span className="highlight-decor">🐾</span>
              <span className="highlight-tag">轻松记录生活</span>
              <span className="highlight-tag">自由表达想法</span>
              <span className="highlight-tag">温暖小狗氛围</span>
              <span className="highlight-decor">🐾</span>
            </div>
          </div>
        </div>
        
        <div className="hero-bg-decor">
          <span className="bg-decor-item">🐶</span>
          <span className="bg-decor-item">🐾</span>
          <span className="bg-decor-item">☕</span>
        </div>
      </section>

      {/* 卡片式功能入口 */}
      <div className="about-tabs profile-nav">
        <button 
          className={`nav-btn ${activeTab === 'profile' ? 'active core-tab' : ''}`}
          onClick={() => setActiveTab('profile')}
        >
          <span className="puppy-icon-small">🐾</span> 我的资料
        </button>
        <button 
          className={`nav-btn ${activeTab === 'articles' ? 'active core-tab' : ''}`}
          onClick={() => setActiveTab('articles')}
        >
          <span className="puppy-icon-small">📝</span> 我的文章
          <span className="article-count-badge">{userStats.posts + userStats.drafts}</span>
        </button>
        <button 
          className={`nav-btn ${activeTab === 'settings' ? 'active' : ''}`}
          onClick={() => setActiveTab('settings')}
        >
          <span className="puppy-icon-small">⚙️</span> 账号设置
        </button>
        <button 
          className={`nav-btn ${activeTab === 'about-site' ? 'active' : ''}`}
          onClick={() => setActiveTab('about-site')}
        >
          <span className="puppy-icon-small">📖</span> 关于平台
        </button>
      </div>

      {/* 内容区域 */}
      <div className="about-content">
        {/* 1. 我的资料标签页 */}
        {activeTab === 'profile' && (
          <div className="tab-content profile-tab">
            <div className="profile-section">
              <h2 className="profile-title">🐶 我的个人资料</h2>
             <div className="profile-card" style={{
                  border: '2px solid #ffccd8',
                   borderRadius: '12px',
                   padding: '20px',
                  background: '#fff5f8',
                  display: 'flex', // 新增：头像和资料横向排列
                  gap: '20px', // 新增：头像和资料间距
                  alignItems: 'flex-start', // 顶部对齐
                  flexWrap: 'wrap', // 响应式换行
}}>
                {/* 头像区域（实现上传功能） */}
                <div className="avatar-container" style={{ flexShrink: 0 }}>
                  <label htmlFor="avatar-upload" className="profile-avatar-wrapper">
                    <div className="profile-avatar">{userInfo.avatar || '🐶'}</div>
                    <span className="avatar-edit-icon">📸</span>
                  </label>
                  <input 
                    type="file" 
                    id="avatar-upload" 
                    className="avatar-upload-input"
                    accept="image/png,image/jpeg,image/gif"
                    onChange={(e) => handleAvatarUpload(e)}
                  />
                  <span className="avatar-tip">支持png/jpg/gif格式，大小不超过5MB</span>
                </div>
                
                {/* 资料编辑区域（文字层级区分） */}
                <div className="profile-info"style={{ flex: 1, minWidth: '250px' }}>
                  {!editingProfile ? (
                    <>
                      <div className="info-item">
                        <label className="info-label">昵称：</label>
                        <span className="info-value nickname">{userInfo.nickname}</span>
                      </div>
                      <div className="info-item">
                        <label className="info-label">个人简介：</label>
                        <p className="info-value intro">{userInfo.intro}</p>
                      </div>
                      <button className="edit-profile-btn" onClick={handleEditProfile}>
                        编辑资料 📝
                      </button>
                    </>
                  ) : (
                    <>
                      <div className="info-item edit-item">
                        <label className="info-label">昵称：</label>
                        <input
                          type="text"
                          value={tempUserInfo.nickname}
                          onChange={(e) => setTempUserInfo({...tempUserInfo, nickname: e.target.value})}
                          maxLength={20}
                          className="profile-input"
                        />
                      </div>
                      <div className="info-item edit-item">
                        <label className="info-label">个人简介：</label>
                        <textarea
                          value={tempUserInfo.intro}
                          onChange={(e) => setTempUserInfo({...tempUserInfo, intro: e.target.value})}
                          maxLength={500}
                          className="intro-input"
                          rows={4}
                        />
                        <div className="word-count">{tempUserInfo.intro.length}/500</div>
                      </div>
                      {saveError && <div className="save-error">{saveError}</div>}
                      <div className="edit-actions">
                        <button className="save-btn" onClick={handleSaveProfile}>
                          保存 ✅
                        </button>
                        <button className="cancel-btn" onClick={handleCancelEdit}>
                          取消 ❌
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* 2. 我的文章标签页（修复显示问题） */}
        {activeTab === 'articles' && (
          <div className="tab-content articles-tab">
            <div className="articles-section">
              <h2 className="profile-title">📝 我的文章管理</h2>
              <div className="article-stats">
                <span className="stat-badge published-badge">已发布：{userStats.posts}</span>
                <span className="stat-badge draft-badge">草稿：{userStats.drafts}</span>
              </div>
              
              {/* 空状态处理（修复跳转路径） */}
              {myArticles.length === 0 ? (
                <div className="empty-articles">
                  <p>你还没有发布过文章哦 🐾</p>
                  <button 
                    className="go-write-btn" 
                    onClick={() => navigate('/write')} // 修复：改为/write
                  >
                    去写文章 →
                  </button>
                </div>
              ) : (
                <div className="articles-list">
                  {myArticles.map((article) => (
                    <div key={article.id} className="article-card">
                      <div className="article-header">
                        <h3 className="article-title">{article.title}</h3>
                        <span className={`status-tag ${article.status}`}>
                          {article.status === 'draft' ? '草稿 📝' : '已发布 ✨'}
                        </span>
                      </div>
                      <div className="article-meta">
                        <span className="publish-time">最后更新：{new Date(article.updatedAt).toLocaleDateString()}</span>
                        <span className="read-count">阅读量：{article.readCount}</span>
                      </div>
                      <div className="article-excerpt">{article.content?.slice(0, 100) || '无内容'}...</div>
                      <div className="article-actions">
                        <button 
                          className="action-btn edit-btn" 
                          onClick={() => handleEditArticle(article.id)}
                        >
                          编辑 ✏️
                        </button>
                        {article.published && (
                          <button 
                            className="action-btn preview-btn" 
                            onClick={() => handlePreviewArticle(article.id)}
                          >
                            预览 👁️
                          </button>
                        )}
                        <button 
                          className="action-btn delete-btn" 
                          onClick={() => openDeleteConfirm(article.id)}
                        >
                          删除 🗑️
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}

        {/* 3. 账号设置标签页（实现修改密码等功能） */}
        {activeTab === 'settings' && (
          <div className="tab-content settings-tab">
            <div className="settings-section">
              <h2 className="profile-title">⚙️ 账号设置</h2>
              
              <div className="settings-card" style={{
                border: '2px solid #ffccd8',
                borderRadius: '12px',
                padding: '20px',
                background: '#fff5f8'
              }}>
                <div className="setting-item">
                  <label className="info-label">修改密码</label>
                  <button className="setting-btn" onClick={() => setShowPwdModal(true)}>去修改 📝</button>
                </div>
                <div className="setting-item">
                  <label className="info-label">隐私设置</label>
                  <button className="setting-btn" onClick={() => alert('隐私设置：可设置文章是否公开、个人资料是否可见 🐶')}>去设置 🔒</button>
                </div>
                <div className="setting-item">
                  <label className="info-label">绑定手机号</label>
                  <button className="setting-btn" onClick={() => alert('请输入手机号：_______，验证码：_______ 📱')}>去绑定 📱</button>
                </div>
              </div>
              
              {/* 精简版FAQ */}
              <div className="faq-collapse">
                <div className="faq-collapse-header" onClick={(e) => {
                  const content = e.target.nextElementSibling;
                  content.style.display = content.style.display === 'block' ? 'none' : 'block';
                }}>
                  🐶 常见问题
                </div>
                <div className="faq-collapse-content">
                  {simplifiedFaqs.map((faq, index) => (
                    <div key={index} className="simple-faq-item">
                      <div className="faq-question">{faq.question}</div>
                      <div className="faq-answer">{faq.answer}</div>
                    </div>
                  ))}
                  <div className="more-faq-link">查看更多问题 →</div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* 4. 关于平台标签页 */}
        {activeTab === 'about-site' && (
          <div className="tab-content about-site-tab">
            <div className="about-site-section">
              <h2 className="profile-title">📖 关于 Puppy Log</h2>
              <div className="site-slogan">用小狗般的温柔，记录生活的小确幸</div>
              
              <div className="site-stats">
                <div className="stat-item">
                  <span className="stat-num">{loadingStats ? '...' : `${siteStats?.totalAuthors || 1200}+`}</span>
                  <span className="stat-label">创作者</span>
                </div>
                <div className="stat-item">
                  <span className="stat-num">{loadingStats ? '...' : `${siteStats?.totalPosts || 5800}+`}</span>
                  <span className="stat-label">篇文章</span>
                </div>
              </div>
              
              <div className="timeline-section simplified-timeline">
                <h3>⏳ 发展历程</h3>
                <div className="timeline">
                  {simplifiedMilestones.map((milestone, index) => (
                    <div key={index} className="milestone">
                      <div className="milestone-marker">
                        <span className="milestone-year">{milestone.year}</span>
                        <span className="milestone-month">{milestone.month}</span>
                      </div>
                      <div className="milestone-content">
                        <h4>{milestone.event}</h4>
                        <p>{milestone.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              
              <div className="contact-section simplified-contact">
                <h3>📬 联系我们</h3>
                <div className="contact-method">
                  <span className="method-icon">📧</span>
                  <p>hello@puppylog.com</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* 删除确认弹窗 */}
      <div className="delete-confirm-modal" ref={deleteConfirmRef}>
        <div className="modal-content">
          <div className="modal-header">🐶 确认删除文章</div>
          <div className="modal-body">确定要删除这篇文章吗？删除后就找不回来啦 🐾</div>
          <div className="modal-footer">
            <button className="cancel-delete-btn" onClick={closeDeleteConfirm}>再想想 🐕</button>
            <button className="confirm-delete-btn" onClick={confirmDeleteArticle}>确认删除 🗑️</button>
          </div>
        </div>
      </div>

      {/* 修改密码弹窗 */}
      {showPwdModal && (
        <div className="modal overlay-modal">
          <div className="modal-content pwd-modal">
            <div className="modal-header">🔒 修改密码</div>
            <div className="modal-body">
              <div className="pwd-input-item">
                <label className="info-label">原密码：</label>
                <input 
                  type="password" 
                  value={oldPwd} 
                  onChange={(e) => setOldPwd(e.target.value)}
                  placeholder="请输入原密码"
                  className="pwd-input"
                />
              </div>
              <div className="pwd-input-item">
                <label className="info-label">新密码：</label>
                <input 
                  type="password" 
                  value={newPwd} 
                  onChange={(e) => setNewPwd(e.target.value)}
                  placeholder="6-16位字母/数字"
                  className="pwd-input"
                />
              </div>
              <div className="pwd-input-item">
                <label className="info-label">确认新密码：</label>
                <input 
                  type="password" 
                  value={confirmPwd} 
                  onChange={(e) => setConfirmPwd(e.target.value)}
                  placeholder="再次输入新密码"
                  className="pwd-input"
                />
              </div>
              {pwdError && <div className="pwd-error">{pwdError}</div>}
            </div>
            <div className="modal-footer">
              <button className="cancel-btn" onClick={() => setShowPwdModal(false)}>取消 ❌</button>
              <button className="confirm-btn" onClick={handleUpdatePwd}>确认修改 ✅</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default About;